import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
// Material Design Icons - Off line
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

Vue.use(Vuetify);

// Translation provided by Vuetify (typescript)
import { pt, en, es } from 'vuetify/lib/locale'

export default new Vuetify({
    lang: {
        locales: { pt, en, es },
        current: 'en',
      },
      // Material Design Icons - Off line
      icons: {
        iconfont: 'mdi', // default - only for display purposes
      },
});



